var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ag-btn",style:('width:' + _vm.width + '%'),attrs:{"disabled":_vm.disabled},on:{"click":_vm.nav}},[_c('span',[_vm._v(_vm._s(_vm.desc))]),(_vm.loading)?_c('span',{staticClass:"spinner-border spinner-border-sm ml-2",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }